var _polygon, _rect, _path, _ellipse, _rect2, _rect3, _rect4, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJde(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.5 23.43",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.6 23.26 0 22.92 4.24 2.76 27.29 2.76 31.5 22.92 29.9 23.25 25.96 4.4 5.57 4.4 1.6 23.26"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21.5,
    width: 29.48,
    height: 1.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.17,22.26H20.53c0-1.18-1.89-2.49-4.61-2.49s-4.61,1.31-4.61,2.49H9.66c0-2.31,2.75-4.13,6.25-4.13S22.17,19.94,22.17,22.26Z",
    transform: "translate(-0.15 -0.1)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.75,
    cy: 7.33,
    rx: 0.4,
    ry: 0.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.23,
    y: 0.26,
    width: 0.52,
    height: 3.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.92,
    y: 0.26,
    width: 0.52,
    height: 3.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    width: 9.21,
    height: 0.52
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.35 9.28 6.15 9.28 7.07 4.11 8.17 4.3 7.48 8.17 23.99 8.17 23.18 4.15 24.27 3.93 25.35 9.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "21.89 6.67 9.58 6.67 9.75 4.2 10.87 4.28 10.78 5.55 20.71 5.55 20.64 4.27 21.75 4.21 21.89 6.67"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJde);
export default __webpack_public_path__ + "static/media/jde.7fe8bb2a311d392cb4b8fab84dd76ad6.svg";
export { ForwardRef as ReactComponent };